import React, { useEffect } from 'react';

const CSE_ID = 'a741be4b2784349c7';

const GoogleSearch = () => {
  useEffect(() => {
    // Only inject the script if it hasn't been added yet
    if (!window.__gcse) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://cse.google.com/cse.js?cx=${CSE_ID}`;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <main className="flex-1 p-4 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-[80vh]">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
          <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" alt="Google" className="h-7 mr-2" />
          Custom Search
        </h2>
        {/* Google CSE search box and results will appear here */}
        <div className="gcse-search"></div>
        <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">
          Powered by Google Custom Search Engine
        </div>
      </div>
    </main>
  );
};

export default GoogleSearch; 